import React from 'react';
import { CardActionArea, Grid } from '@mui/material';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';

const EducationVideosPage = () => {
    return (
        <>
            {/* İlk satır: 1. ve 2. kart */}
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} md={6}>
                    <JumboCardQuick
                        title="Değerlendirme İşlemi"
                        sx={{ width: '100%', height: '650px' }}
                    >
                        <CardActionArea>
                            <iframe
                                width="100%"
                                height="550"
                                src="https://www.youtube.com/embed/zT44L7mfEF8?si=0I8kFAF7BEgofaPN"
                                title="Değerlendirme İşlemi"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            />
                        </CardActionArea>
                    </JumboCardQuick>
                </Grid>
                <Grid item xs={12} md={6}>
                    <JumboCardQuick
                        title="Oy Verme İşlemi"
                        sx={{ width: '100%', height: '650px' }}
                    >
                        <CardActionArea>
                            <iframe
                                width="100%"
                                height="550"
                                src="https://www.youtube.com/embed/Uk-799HptCs?si=QOjT07PVTBfvEfHR"
                                title="Oy Verme İşlemi"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            />
                        </CardActionArea>
                    </JumboCardQuick>
                </Grid>
            </Grid>

            {/* İkinci satır: sadece 3. kart (solda hizalı) */}
            <Grid container spacing={2} justifyContent="flex-start" sx={{ marginTop: 2 }}>
                <Grid item xs={12} md={6}>
                    <JumboCardQuick
                        title="Diğer Bilgiler"
                        sx={{ width: '100%', height: '650px' }}
                    >
                        <CardActionArea>
                            <iframe
                                width="100%"
                                height="550"
                                src="https://www.youtube.com/embed/UkLMvZfANQE?si=5bFDTOtorj-vQvSG"
                                title="Diğer Bilgiler"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </CardActionArea>
                    </JumboCardQuick>
                </Grid>
            </Grid>
        </>
    );
};

export default EducationVideosPage;